<div *ngIf="countdown != null" class="timer" style="width: 65px">
  <label class="label-tempo" style="color:#fff !important">
    <span class="glyphicon glyphicon-time"></span>
    <span>{{ countdown | secondstotime }}s</span>
  </label>
</div>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵbo.html